import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { Avatar, Skeleton, DefaultAvatar } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'

const StyledAvatarLink = styled.a`
  display: contents;
  text-decoration: none;
`

type LinkedAvatarProps = {
  name?: string
  avatarUrl?: string
  url?: string
  diameter?: string
  fallbackFontSize?: string
}

const LinkedAvatar = ({
  name,
  avatarUrl,
  url,
  diameter = '48px',
  fallbackFontSize = '24px'
}: LinkedAvatarProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledAvatarLink
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={(event) => {
        event.stopPropagation()
      }}>
      {name ? (
        <Avatar
          mode={theme}
          src={avatarUrl}
          diameter={diameter}
          loader={
            <Skeleton variation="circle" width={diameter} height={diameter} animation="wave" />
          }
          alt={name}
          variant="circular"
          fallbackStyles={{ fontSize: fallbackFontSize, fontWeight: 400, cursor: 'pointer' }}
        />
      ) : (
        <DefaultAvatar mode={theme} fontSize={Number(diameter.replace('px', ''))} />
      )}
    </StyledAvatarLink>
  )
}

export default LinkedAvatar
